/* unplugin-vue-components disabled */import { render } from "./albumDesc.vue?vue&type=template&id=566475ac&scoped=true&ts=true"
import script from "./albumDesc.vue?vue&type=script&lang=ts"
export * from "./albumDesc.vue?vue&type=script&lang=ts"

import "./albumDesc.vue?vue&type=style&index=0&id=566475ac&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566475ac"],['__file',"src/views/albumDetail/cpns/albumDesc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "566475ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('566475ac', __exports__)) {
    console.log('reload')
    api.reload('566475ac', __exports__)
  }
  
  module.hot.accept("./albumDesc.vue?vue&type=template&id=566475ac&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('566475ac', render)
  })

}


export default __exports__